export const meta = {
  id: 'A01',
  slug: 'visao-geral',
  title: 'Conheça a tela Hoje',
  description: 'Use a tela Hoje para identificar o que merece sua atenção agora.',
  profile: 'student',
  category: 'hoje',
  type: 'screen',
  status: 'published',
  order: 50,
  keywords: ['hoje', 'próxima ação', 'pendências', 'o que fazer agora', 'início'],
  previous: 'G03',
  next: 'A02',
  related: ['A03', 'A05', 'A06'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Conheça a tela Hoje

A tela **Hoje** responde à pergunta: **“O que preciso fazer agora?”**. Ela muda de acordo com seu momento no Personagrama.

## O que pode aparecer

Dependendo do seu progresso, Hoje pode orientar você a iniciar o Diagnóstico, continuar seu desenvolvimento, avançar em uma Jornada ou Formação, executar um Treinamento ou atender outra ação disponível.

<HelpImage alt="Tela Hoje com diagnóstico pendente" pendingId="A01.1" />

## Como usar

<Steps>
  <Step title="Abra Hoje">
    Observe a ação ou pendência destacada para seu momento atual.
  </Step>
  <Step title="Acesse a ação indicada">
    Entre diretamente na experiência relacionada.
  </Step>
  <Step title="Execute e registre o progresso">
    Conclua o que estiver disponível e volte a Hoje quando precisar reorientar sua sequência.
  </Step>
</Steps>

<Callout type="concept">
  **Hoje** mostra o que fazer agora. **Meu Desenvolvimento** mostra como você está evoluindo ao longo do tempo.
</Callout>
